var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxCredits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.75C1.5 0.335786 1.16421 0 0.75 0C0.335786 0 0 0.335786 0 0.75V14.75C0 16.5449 1.45507 18 3.25 18H17.25C17.6642 18 18 17.6642 18 17.25C18 16.8358 17.6642 16.5 17.25 16.5H3.25C2.2835 16.5 1.5 15.7165 1.5 14.75V0.75ZM11.75 3C11.3358 3 11 3.33579 11 3.75C11 4.16421 11.3358 4.5 11.75 4.5H14.9393L10.25 9.18934L8.28033 7.21967C7.98744 6.92678 7.51256 6.92678 7.21967 7.21967L3.46967 10.9697C3.17678 11.2626 3.17678 11.7374 3.46967 12.0303C3.76256 12.3232 4.23744 12.3232 4.53033 12.0303L7.75 8.81066L9.71967 10.7803C10.0126 11.0732 10.4874 11.0732 10.7803 10.7803L16.0015 5.55917L16.0015 8.755C16.0015 9.16921 16.3373 9.50499 16.7515 9.50499C17.1658 9.50498 17.5015 9.16919 17.5015 8.75498L17.5015 3.74999C17.5015 3.33578 17.1657 3 16.7515 3H11.75Z",
    fill: "#685879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxCredits);
export default __webpack_public_path__ + "static/media/taxCredits.fada1a8774c55e7dee2a29f4a566b89a.svg";
export { ForwardRef as ReactComponent };